import { render, staticRenderFns } from "./SubNavigation.vue?vue&type=template&id=0ec7604d&scoped=true"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"
import style0 from "./SubNavigation.vue?vue&type=style&index=0&id=0ec7604d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7604d",
  null
  
)

export default component.exports